<template>
<transition name="slide">
<div>
<div style="background-color: #6c757d;" class="row">
<div class="col-md-1 col-sm-1 col-xs-1">
<i class="fa fa-arrow-left fa-fw comment-heading" @click="goBack()"></i>
</div>
<div class="col-md-11 col-sm-11 col-xs-11">
<h4 class="comment-heading">Comments</h4>
</div>
</div>
<div class="assessment-task-title">{{history_title}}</div>
<div class="" v-for="assessment in history_comment">
<div class="comment-wrapper mx-auto">
  <div class="tip left">

  <div class="row">
  <div class="col-12">
    <span class="assessment-task-score float-left">Score: {{assessment.score}}</span>
    <span class="comment-date float-right"><i class="fa fa-clock-o"> {{assessment.createdAt | formatDate}}</i></span>
  </div>
  </div>

    <div class="row">
    <div class="col-12 comment-text">
      {{assessment.comment}}
    </div>
    </div>
    <div class="row">
      <div class="col-12 posted-by-text float-right">
        <span class="posted-by-mob float-right">Commented by: {{assessment.mentor_name}}</span>

      </div>
    </div>

  </div>
   </div>
</div>
<div v-if="history_comment.length == 0 && assessment_loading == false" class="comment-wrapper mx-auto">
  <div class="col-12 float-left override-padding">
    No Assessments Found.
  </div>
</div>
</div>
</transition>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import moment from 'moment';
import router from '../../router/index.js';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

export default {
  data() {
   return {
      history_title: '',
      history_comment: '',
      'task_array': [],
      tasklist_id: '',
      'assessment_loading': false,
      from: null,
    }
  },
  beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.from = from;
        });
  },
  methods: {
    openHistoryModal(mentee, task_id) {
      this.assessment_loading = true;
      axios.get('/assessment', {
        params: {
          mentee_id: mentee,
          task_id: task_id,
          tasklist_id: this.tasklist_id,
        }
      })
      .then(response =>  {
        this.history_title = response.data.task.description;
        this.history_comment = response.data.history;
        this.assessment_loading = false;
      })
      .catch(function(error) {

      });
   },
   goBack() {
     var prevpage_url = document.referrer;
     this.task_array = this.$route.params.parent_task_id.split('@');
     if(prevpage_url.match(/students-task/g)) {
       this.navigate("/students-task/" + this.$route.params.mentee_id + "?e1=" + this.task_array[2] + "&e2=" + this.task_array[1] + "&e3=" + this.$route.params.task_id + "&e4=" + this.task_array[0] + "");
     }
     else {
       this.navigate("/mentees-task/" + this.$route.params.mentee_id + "?e1=" + this.task_array[2] + "&e2=" + this.task_array[1] + "&e3=" + this.$route.params.task_id + "&e4=" + this.task_array[0] + "");
     }
   },
   navigate(path) {
     router.push(path);
   },

  },
  created: function() {
    var mentee_id = this.$route.params.mentee_id;
    var task_id = this.$route.params.task_id;
    this.task_array = this.$route.params.parent_task_id.split('@');
    this.tasklist_id = this.task_array[0];
    this.openHistoryModal(mentee_id, task_id);
  },
  beforeCreate: function() {
    document.body.className = 'task-assessment-page';
  }
}
</script>

<style scoped>
.comment-heading {
  background-color: #6c757d;
  padding: 12px 5px 12px 5px;
  font-size: 18px;
  color: #FFF;
  margin-top: 0px;
}
.comment-wrapper {
  padding: 5px;
  background-color: #FFF;
  width: 90%;
  min-height: 100px;
}
.assessment-task-title {
  margin: 10px 5px 5px 5px;
  border-bottom: 1px solid #DDD;
  padding-bottom: 5px;
}
.assessment-task-score {
  font-weight: bold;
}
.comment-text {
  margin-top: 5px;
}
.tip:before {
  position: absolute;
  top: -14px;
  left: 98px;
  display: inline-block;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #fff;
  border-left: 14px solid transparent;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  content: '';
}

.tip:after {
  position: absolute;
  top: -12px;
  left: 99px;
  display: inline-block;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #fff;
  border-left: 12px solid transparent;
  content: '';
}

.tip.left:before {
  border-top: 14px solid transparent;
  border-right: 14px solid #fff;
  border-bottom: 14px solid transparent;
  border-right-color: rgba(169, 169, 169, 1);
  left: -28px;
  top: 20px;
}

.tip.left:after {
  border-top: 12px solid transparent;
  border-right: 12px solid #fff;
  border-bottom: 12px solid transparent;
  left: -24px;
  top: 22px;
}
.tip-left {
  top: 10px;
  left: -25px;
  border-top-color: transparent;
  border-left-color: transparent;
  border-bottom-color: transparent;
}
.tip {
		background: #FFF;
		border: 2px solid #ccc;
		padding: 10px;
		position: relative;
	}
.dialogbox .body {
  position: relative;
  max-width: 300px;
  height: auto;
  margin: 20px 10px;
  padding: 5px;
  border-radius: 3px;
  border: 5px solid #ccc;
}

.body .message {
  min-height: 30px;
  border-radius: 3px;
  font-family: "proxima-nova",sans-serif;
  color: #002F42;
  font-size: 14px;
  line-height: 1.5;
}
.slide-leave-active,
.slide-enter-active {
      transition: 0.4s;
}
.slide-enter {
    transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
@media (max-width: 575.98px) {
  .col-xs-1 {
   width: 8.33333333%;
  }
  .col-xs-11 {
    width: 91.66666667%;
  }
  .col-xs-4 {
    width: 33.333333%;
  }
  .col-xs-8 {
    width: 66.666667%;
  }
  .col-xs-9 {
    width: 75%;
  }
  .col-xs-3 {
    width: 25%;
  }
}
.row {
  margin-left: 0px;
  margin-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/task_assessment_view.vue